// sagas.js

import { takeLatest, put, call } from 'redux-saga/effects';
import * as ActionTypes from './actionsTypes';
import { getCall } from '../../../../helpers/fakebackend_helper'; // Create an API function to make the API call
//restapi end point
import * as constClass from "../../../../common/constant/constantURL"
import { saveLinkedinCompanyFailure, saveLinkedinCompanySuccess } from './actions';
function* validateAccessTokenSaga() {
  try {
    const response = yield call(getCall, constClass.LINKEDIN_VALIDATION_TOKEN);
    yield put({ type: ActionTypes.VALIDATE_ACCESS_TOKEN_SUCCESS, data: "success" });
  } catch (error) {
    yield put({ type: ActionTypes.VALIDATE_ACCESS_TOKEN_FAILURE, error });
  }
}
function* saveLinkedinCompany(action) {
  try {
    const {linkedinCompanyId } = action;
    let url= constClass.LINKEDIN_SAVE_ORG_ID+'?linkedinCompanyId='+linkedinCompanyId
    const response = yield call(getCall,url);
    yield put(saveLinkedinCompanySuccess("success"));
  } catch (error) {
    yield put(saveLinkedinCompanyFailure(error));
  }
}
export function* linkedinSaga() {
  yield takeLatest(ActionTypes.VALIDATE_ACCESS_TOKEN_REQUEST, validateAccessTokenSaga);
  yield takeLatest(ActionTypes.SAVE_LINKEDIN_COMPANY_REQUEST, saveLinkedinCompany);
}

export default linkedinSaga